import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../src/images/nav/logot.png";
import { logout } from "../redux/authSlice";

const NavbarT = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false); // For Hamburger Menu
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const handleLogout = () => setLogoutModalOpen(true);

  const confirmLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    localStorage.removeItem("authExpiration");
    dispatch(logout());
    setLogoutModalOpen(false);
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuVisible((prev) => !prev);
  };

  const cancelLogout = () => setLogoutModalOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`flex items-center justify-between lg:gap-0 gap-10 w-full z-50 fixed top-0 transition-all duration-500 ease-in-out font-clash
          ${
            isScrolled
              ? "h-16 p-2 bg-[#1F1F1F] bg-opacity-20 backdrop-blur-sm"
              : "lg:h-24 p-4 h-[80px] lg:bg-[#71892986] backdrop-blur-sm"
          }`}
      >
        {/* Logo Section */}
        <div
          className={`flex items-center ml-[-20px] bg-[#1F1F1F] transition-all duration-500 ease-in-out ${
            isScrolled ? "h-16" : "h-24"
          }`}
        >
          <img src={logo} alt="imagelogo" className="object-contain h-full" />
        </div>

        {/* Links Section for large screens */}
        <div className="hidden lg:flex items-center justify-around space-x-16 text-white ml-10">
          <Link to="/technician-dashboard" className="mx-2">
            Technician Dashboard
          </Link>
          <Link to="/technician/tasks" className="mx-2">
            My Jobs
          </Link>
        </div>

        {/* Hamburger Menu Button for small and medium screens */}
        <button
  className="lg:hidden focus:outline-none z-50"
  onClick={() => setMenuOpen((prev) => !prev)} // Using setMenuOpen here
>
  <div
    id="nav-icon4"
    className={`cursor-pointer ${isMenuOpen ? "open" : ""}`} // Changed from isMobileMenuOpen to isMenuOpen
    style={{
      width: "40px",
      height: "30px",
      position: "relative",
      margin: "20px auto",
      transform: "rotate(0deg)",
      transition: "0.5s ease-in-out",
    }}
  >
    {/* Top Line */}
    <span
      style={{
        display: "block",
        position: "absolute",
        height: "2px",
        width: "100%",
        background: "#F0FFC5",
        borderRadius: "2px",
        left: 0,
        top: 0,
        transformOrigin: "center",
        transition: "0.25s ease-in-out",
        ...(isMenuOpen && {
          transform: "rotate(45deg)",
          top: "12px", // Move to the center for X
        }),
      }}
    ></span>

    {/* Middle Line */}
    <span
      style={{
        display: "block",
        position: "absolute",
        height: "2px",
        width: "100%",
        background: "#F0FFC5",
        borderRadius: "2px",
        left: 0,
        top: "12px",
        transformOrigin: "center",
        transition: "0.25s ease-in-out",
        ...(isMenuOpen && {
          transform: "scale(0)", // Disappear when forming the X
        }),
      }}
    ></span>

    {/* Bottom Line */}
    <span
      style={{
        display: "block",
        position: "absolute",
        height: "2px",
        width: "100%",
        background: "#F0FFC5",
        borderRadius: "2px",
        left: 0,
        top: "24px",
        transformOrigin: "center",
        transition: "0.25s ease-in-out",
        ...(isMenuOpen && {
          transform: "rotate(-45deg)",
          top: "12px", // Move to the center for X
        }),
      }}
    ></span>
  </div>
</button>


        {/* Profile and Logout Button for large screens */}
        <div className="hidden lg:flex items-center space-x-4">
          {user?.profileImage && (
            <img
              src={user.profileImage}
              alt={user.username}
              className="w-10 h-10 rounded-full object-cover"
            />
          )}
          <button
            onClick={handleLogout}
            className="px-4 py-2 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300"
          >
            Logout
          </button>
        </div>
      </nav>

      {/* Mobile Menu for sm and md */}
      {isMenuOpen && (
        <div className="fixed inset-0 flex flex-col px-5 items-start mt-5 bg-black bg-opacity-90 text-white z-40 lg:hidden">
          <div className="flex justify-end w-full p-4">
            <button
              className="text-white text-2xl"
              onClick={() => setMenuOpen(false)}
            >
              ×
            </button>
          </div>
          <nav className="flex flex-col space-y-6 text-lg mt-4">
            <Link
              to="/technician-dashboard"
              className="mx-2"
              onClick={() => setMenuOpen(false)}
            >
              Technician Dashboard
            </Link>
            <Link
              to="/technician/tasks"
              className="mx-2"
              onClick={() => setMenuOpen(false)}
            >
              My Jobs
            </Link>
            <Link
              to="/"
              className="mx-2"
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
            {user?.profileImage && (
              <img
                src={user.profileImage}
                alt={user.username}
                className="w-16 h-16 rounded-full object-cover mx-auto"
              />
            )}
            <button
              onClick={handleLogout}
              className="px-5 py-2 mr-36 rounded-full border bg-black bg-opacity-50 border-[#718929] text-[#F0FFC5] hover:bg-opacity-70 transition-all duration-300 mx-auto"
            >
              Logout
            </button>
          </nav>
        </div>
      )}

      {/* Logout Modal */}
      {isLogoutModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-xl mb-4">Are you sure you want to logout?</h2>
            <div className="flex justify-end space-x-4">
              <button
                onClick={cancelLogout}
                className="px-4 py-2 bg-gray-300 rounded-full hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-600"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavbarT;
